import { logError } from '@zg-rentals/log-error';
import type { ZrmListingInfo } from '@zg-rentals/clickstream';
import type { ApplicationContextValue } from '../contexts/ApplicationContext';

const nullValues = {
  zrm_listing_info: {
    listing_id: null,
    applications_ind: null,
    rental_protection_ind: null,
    product_type_txt: null,
    previously_activated_ind: null,
    property_type_cd: null,
    manual_ind: null,
  },
};

export function getZrmListingInfo(applicationContext: ApplicationContextValue | undefined): ZrmListingInfo {
  try {
    // return null values if applicationContext is not available
    if (!applicationContext) {
      return nullValues;
    }
    const { application } = applicationContext;
    const { rentalListing } = application;
    const listing_id = rentalListing?.listingAlias ?? null;
    return {
      zrm_listing_info: {
        ...nullValues.zrm_listing_info,
        listing_id,
      },
    };
  } catch (error) {
    logError({ error, context: 'getZrmListingInfo' });
    return nullValues;
  }
}
